var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 0.666667C0.833333 0.758714 0.758714 0.833333 0.666667 0.833333C0.574619 0.833333 0.5 0.758714 0.5 0.666667C0.5 0.574619 0.574619 0.5 0.666667 0.5C0.758714 0.5 0.833333 0.574619 0.833333 0.666667Z",
    fill: "#171E3C",
    stroke: "#171E3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 3.99992C0.833333 4.09197 0.758714 4.16659 0.666667 4.16659C0.574619 4.16659 0.5 4.09197 0.5 3.99992C0.5 3.90787 0.574619 3.83325 0.666667 3.83325C0.758714 3.83325 0.833333 3.90787 0.833333 3.99992Z",
    fill: "#171E3C",
    stroke: "#171E3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 7.33341C0.833333 7.42546 0.758714 7.50008 0.666667 7.50008C0.574619 7.50008 0.5 7.42546 0.5 7.33341C0.5 7.24137 0.574619 7.16675 0.666667 7.16675C0.758714 7.16675 0.833333 7.24137 0.833333 7.33341Z",
    fill: "#171E3C",
    stroke: "#171E3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29317 3.83325H11.3732C11.4431 3.83325 11.4998 3.88996 11.4998 3.95992V4.03992C11.4998 4.10987 11.4431 4.16659 11.3732 4.16659H3.29317C3.22321 4.16659 3.1665 4.10987 3.1665 4.03992V3.95992C3.1665 3.88996 3.22321 3.83325 3.29317 3.83325Z",
    fill: "#171E3C",
    stroke: "#171E3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29317 7.16675H11.3732C11.4431 7.16675 11.4998 7.22346 11.4998 7.29341V7.37341C11.4998 7.44337 11.4431 7.50008 11.3732 7.50008H3.29317C3.22321 7.50008 3.1665 7.44337 3.1665 7.37341V7.29341C3.1665 7.22346 3.22321 7.16675 3.29317 7.16675Z",
    fill: "#171E3C",
    stroke: "#171E3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29317 0.5H11.3732C11.4431 0.5 11.4998 0.556711 11.4998 0.626667V0.706667C11.4998 0.776622 11.4431 0.833333 11.3732 0.833333H3.29317C3.22321 0.833333 3.1665 0.776623 3.1665 0.706667V0.626667C3.1665 0.556711 3.22321 0.5 3.29317 0.5Z",
    fill: "#171E3C",
    stroke: "#171E3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/menu2.dd13aadd2611d9763dd0691172ba2e37.svg";
export { ForwardRef as ReactComponent };